import React from "react";
import "./FormErrorMessage.css";

interface Props {
  children: React.ReactNode;
}

function FormErrorMessage(props: Props) {
  const { children } = props;
  const BlockingSpace = '\u00A0'; // prevent flex jump when error "appears"

  return <div className="form-error-msg">{children || BlockingSpace}</div>;
}

export default FormErrorMessage;
